//--------------- IMPORTAÇÕES ---------------//
import { useContext, useEffect } from "react";
import { loadLeadsService, loadPurchasesUserService, loadTagsUserService } from "../services";
import { LeadsContext } from "../context/LeadsContext";



//--------------- EXPORTAÇÃO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
export default function ContainerLeads() {



    //----------- CRIAÇÃO DE HOOKS -----------//
    const { leads, setLeads } = useContext(LeadsContext);
    const { itemsPerPage, setItemsPerPage } = useContext(LeadsContext);
    const { search, setSearch } = useContext(LeadsContext);
    const { currentPage, setCurrentPage } = useContext(LeadsContext);
    const { statusFilter, setStatusFilter } = useContext(LeadsContext);
    const { tagFilter, setTagFilter } = useContext(LeadsContext);
    const { leadSelected, setLeadSelected } = useContext(LeadsContext);
    const { isOpenModalEditLead, setIsOpenModalEditLead } = useContext(LeadsContext); // Estado que armazena se é para abrir o modal Editar Lead
    const { isOpenModalTags, setIsOpenModalTags } = useContext(LeadsContext); // Estado que armazena se é para abrir o modal Tags
    const { isOpenModalPurchases, setIsOpenModalPurchases } = useContext(LeadsContext); // Estado que armazena se é para abrir o modal Compras
    const { purchasesLead, setPurchasesLead } = useContext(LeadsContext); //Estado que armazena as compras da Lead
    const { leadModalTags, setLeadModalTags } = useContext(LeadsContext);
    const { tagsModalTags, setTagsModalTags } = useContext(LeadsContext);
    const { total, setTotal} = useContext(LeadsContext);
    const { integrationsFilter, setIntegrationsFilter } = useContext(LeadsContext);



    //---------- USE EFFECT QUE ATUALIZA A CADA MUDANÇA DE PÁGINA, DE ITENS POR PÁGINA E DE FILTRAGEM ----------//
    useEffect(() => {
        console.log("Entrou no useEffect de ContainerLeads")
        handleRefreshLeads();
    }, [currentPage, itemsPerPage, search, statusFilter, tagFilter, integrationsFilter]);



    //------------ FUNÇÃO ASSÍNCRONA HANDLE REFRESH LEADS ------------//
    // Responsável por atualizar as leads via API
    // É utilizada a cada mudança nos hooks "currentPage", "itemsPerPage", "filterStatus" e "filterTag"
    // Armazena as leads no Estado "leads"
    // Armazena o total no Estado "total"
    async function handleRefreshLeads() {
        const offset = (currentPage - 1) * itemsPerPage;
        const response = await loadLeadsService(itemsPerPage, offset, search, statusFilter, tagFilter, integrationsFilter);
        if (response) {
            setLeads(response.data.clientes);
            setTotal(response.data.total_clientes);
        }
    };



    //--------------- RETORNO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
    return (
        <>

            {/* DIV QUE CONTÊM AS LEADS */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">


                {/* MAPEAMENTO DAS LEADS */}
                {leads.map(cliente => (

                    <div key={cliente.id} className="bg-surface-2 border border-white/[0.08] rounded-xl p-4 shadow-md hover:shadow-lg transition-shadow">
                        <div className="flex justify-between items-center mb-2">
                            <h3 className="text-lg font-bold text-brand-400 truncate w-3/4">{cliente.nome}<span className="text-xs text-ink-3 ml-2 hidden xl:inline">(ID: {cliente.id})</span></h3>
                            {/* <span className="text-xs text-ink-3">{new Date(cliente.data_criacao).toLocaleDateString("pt-BR")}</span> */}
                        </div>
                        <p className="text-sm text-ink-2 mb-1 block xl:hidden">Id: <span className="text-brand-400">{cliente.id}</span></p>
                        <p className="text-sm text-ink-2 mb-1">📧 {cliente.email}</p>
                        <p className="text-sm text-ink-2 mb-1">📞 {cliente.telefone}</p>
                        {cliente.documento && (
                            <p className="text-sm text-ink-2 mb-1">🪪 {cliente.documento.length === 11 ? "CPF" : "CNPJ"} {cliente.documento.length === 11
                                ? cliente.documento.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
                                : cliente.documento.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")}</p>
                        )}
                        <p className="text-sm text-ink-2 mb-1">Tags: <span className="text-brand-400">{cliente.total_tags}</span></p>
                        <p className="text-sm text-ink-2 mb-2">Comprou: <span className={`font-semibold ${cliente.comprou === "Sim" ? 'text-green-400' : 'text-red-400'}`}>{cliente.comprou}</span></p>
                        <div className="flex flex-wrap gap-2">
                            <button
                                onClick={async () => {
                                    // const response = await loadPurchasesUserService(cliente.id);
                                    // if (response) {
                                    //     setPurchasesLead({ ...cliente, compras: response.data });
                                    //     setIsOpenModalPurchases(true);
                                    // }
                                    setPurchasesLead(cliente);
                                    setIsOpenModalPurchases(true);
                                }}
                                className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-xs"
                            >
                                Ver Compras
                            </button>
                            <button
                                onClick={async () => {
                                    const response = await loadTagsUserService(cliente.id);
                                    if (response) {
                                        setLeadModalTags({ ...cliente });
                                        setTagsModalTags(response.data);
                                        setIsOpenModalTags(true);
                                    }
                                }}
                                className="bg-brand-600 hover:bg-brand-700 text-white px-3 py-1 rounded text-xs"
                            >
                                Ver Tags
                            </button>
                            <button
                                onClick={() => { setLeadSelected(cliente); setIsOpenModalEditLead(true); }}
                                className="bg-surface-3 hover:bg-surface-4 text-white px-3 py-1 rounded text-xs"
                            >
                                Editar
                            </button>
                        </div>
                    </div>
                ))}
            </div>

        </>
    )
}